import { useEffect, useState } from 'react';

/**
 * Returns a value that lags `input` by `delayMs`. Use to debounce
 * search-input round-trips: bind the controlled input to `setSearch`,
 * then derive `useDebouncedValue(search, 300)` for the network call.
 *
 * The trailing value always wins — if the user keeps typing past
 * `delayMs`, the timer resets and only the final value is emitted.
 */
export function useDebouncedValue<T>(input: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(input);
  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(input), delayMs);
    return () => window.clearTimeout(handle);
  }, [input, delayMs]);
  return debounced;
}
